import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {AchFundingSource, PaymentRequest} from "@app/shared/ach/org-payment-transaction";
import {OrgAchDetail} from "@app/shared/classes/org-ach-detail";
import {OrgPaymentConfig} from "@app/shared/classes/org-payment-config";
import {PaymentService} from "@app/shared/services/payment.service";
import {PaymentStatusType} from "@app/shared/enums/payment-status-type.enum";
import {PaymentTxnType} from "@app/shared/enums/txn-type.enum";
import {Format} from "@app/shared/enums/format.enum";
import {Validation} from "@app/shared/enums/validation.enum";
import {FundingSourceType, PaymentType} from "@app/shared/enums/payment-type.enum";
import {DwollaMessages} from "@app/shared/ach/dwolla-messages.enum";
import {FundingSourceRequest} from "@app/shared/ach/ach-select-funding-source/funding-source-request";


import {SelectItem} from "primeng/api";
import {plainToClass} from "class-transformer";
import {UserService} from "@app/core";
import {CurrencyPipe} from "@angular/common";
import { DialogStyle500x650 } from '@app/shared/classes/common';
import {PaymentDialogRequest} from "@app/shared/payment/payment-dialog/payment-dialog-request";
import {CommonTransformationService} from "@app/shared/services/common-transformation.service";

@Component({
  selector: 'app-payment-dialog',
  templateUrl: './payment-dialog.component.html',
  styleUrls: ['./payment-dialog.component.css'],
  providers: [CurrencyPipe]
})
/**
 * Common Component to handle Payments in a dialog.
 */
export class PaymentDialogComponent implements OnInit {

  DialogStyle500x650 = DialogStyle500x650;
  PaymentType: typeof PaymentType = PaymentType;
  PaymentStatusType: typeof PaymentStatusType = PaymentStatusType;
  Format: typeof Format = Format;
  Validation: typeof Validation = Validation;


  //Payment dialog properties

  paymentTypeDropdown: SelectItem[];                  // for payment type dropdown
  sourceAch: AchFundingSource;
  achForCheckPayment: OrgAchDetail;
  destinationAch: AchFundingSource;


  disablePayment: boolean = false;                //To Disable make payment button (used to validate txn amounts)
  displayTransactionExceedsLimitMsg: boolean = false;                //To display txn amount exceeds limit to user
  transactionExceedsLimitMsg: string;
  paymentConfig: OrgPaymentConfig;
  orgFundingSource: FundingSourceRequest;
  destinationFundingSource: FundingSourceRequest;
  paymentType: PaymentType;

  //Override checkNumber
  overRideCheckOrReferenceNumber: string;                      //To Store overidden check number;

  //Check properties
  displayCheckInfo: boolean = false;

  @Input()
  paymentDialogRequest: PaymentDialogRequest;
  @Input()
  displayPaymentDialog: boolean;



  @Output() selectedPaymentRequestEvent = new EventEmitter<PaymentRequest>();
  @Output() cancelPaymentRequestEvent = new EventEmitter<boolean>();



  constructor(private paymentService: PaymentService, private user: UserService, private currencyPipe: CurrencyPipe, private transform: CommonTransformationService) { }

  ngOnInit() {
    this.buildDropDown();
    this.getPaymentConfig();
  }

  buildDropDown() {
    this.buildPaymentTypeDropDown();
  }

  buildPaymentTypeDropDown() {
    this.paymentService.getPaymentTypeAsDropDown(this.paymentDialogRequest.excludePaymentTypes).subscribe(data => {
      this.paymentTypeDropdown = data;
    });
  }

  getPaymentConfig() {
    this.paymentService.getPaymentConfig().subscribe(res => {
      this.paymentConfig = plainToClass(OrgPaymentConfig, res as OrgPaymentConfig);
    });
  }

  createSourceSelectFundingSourceRequest(paymentType: PaymentType) {
    let fundingSourceRequest = new FundingSourceRequest();
    fundingSourceRequest.refId = this.user.info.orgId;
    fundingSourceRequest.fundingSourceType = FundingSourceType.Org;
    fundingSourceRequest.canChangeFundingSource = this.paymentDialogRequest.canChangeSourceFundingSource;
    fundingSourceRequest.label = "Source";
    fundingSourceRequest.paymentType = paymentType;
    fundingSourceRequest.paymentTxnType = this.paymentDialogRequest.paymentTxnType;
    this.orgFundingSource = fundingSourceRequest;
  }

  createDestinationSelectFundingSourceRequest(resourceId: number, paymentType: PaymentType) {
    let fundingSourceRequest = new FundingSourceRequest();
    fundingSourceRequest.refId = resourceId;
    if (this.paymentDialogRequest.paymentTxnType == PaymentTxnType.Payroll) {
      fundingSourceRequest.fundingSourceType = FundingSourceType.Payee;
    } else if (this.paymentDialogRequest.paymentTxnType == PaymentTxnType.VoucherRegister) {
      fundingSourceRequest.fundingSourceType = FundingSourceType.Vendor;
    }
    fundingSourceRequest.canChangeFundingSource = this.paymentDialogRequest.canChangeDestFundingSource;
    fundingSourceRequest.paymentType = paymentType;
    fundingSourceRequest.paymentTxnType = this.paymentDialogRequest.paymentTxnType;
    if (this.paymentDialogRequest.destinationFundingSourceId) {
      fundingSourceRequest.defaultFundingSourceId = this.paymentDialogRequest.destinationFundingSourceId;
    }
    this.destinationFundingSource = fundingSourceRequest;
  }

  createFundingSourceRequest(paymentType: PaymentType) {

    this.destinationFundingSource = null;
    this.orgFundingSource = null;
    if (paymentType == PaymentType.ACH) {
      //Get both source and destination funding source
      this.createSourceSelectFundingSourceRequest(paymentType);
      this.createDestinationSelectFundingSourceRequest(this.paymentDialogRequest.destinationResourceId, paymentType);
    } else if (paymentType == PaymentType.Check) {
      //Get only OrgAch
      this.createSourceSelectFundingSourceRequest(paymentType);
      this.destinationFundingSource = null;
    }


  }

  onChangePaymentType(paymentType: PaymentType) {
    this.createFundingSourceRequest(paymentType);
    if (this.paymentDialogRequest.paymentAmount) {
      //this.calculateFeesForPayment(this.vrsToPay.amountPaid);
      this.validateTransactionAmount(this.paymentDialogRequest.paymentAmount, this.paymentType);
    }
  }

  validateTransactionAmount(amountToPay: number, paymentType: PaymentType) {
    if (this.paymentConfig && this.paymentConfig.achConfig) {
      if (paymentType == PaymentType.ACH && amountToPay > this.paymentConfig.achConfig.maxLimitPerTransaction) {
        this.disablePayment = true;
        this.displayTransactionExceedsLimitMsg = true;
        this.transactionExceedsLimitMsg = DwollaMessages.AchMaximumLimitMessage.replace("{{txnLimit}}", this.currencyPipe.transform(this.paymentConfig.achConfig.maxLimitPerTransaction, Format.Currency));
      } else {
        this.disablePayment = false;
        this.displayTransactionExceedsLimitMsg = false;
      }
    } else {
      this.disablePayment = false;
      this.displayTransactionExceedsLimitMsg = false;
    }
  }

  onSelectOrgFundingSource($event, paymentType: PaymentType) {

    if (paymentType == PaymentType.ACH) {
      this.sourceAch = $event;
    } else if (paymentType == PaymentType.Check) {
      this.achForCheckPayment = $event;
    }
  }

  onSelectDestinatioFundingSource($event) {
    this.destinationAch = $event;
  }

  onClickCancelPaymentDialog() {
    this.displayPaymentDialog = false;
    this.displayTransactionExceedsLimitMsg = false;
    this.overRideCheckOrReferenceNumber = null;
    this.cancelPaymentRequestEvent.emit(true);
  }

  onClickMakePayment() {
    let paymentRequest = this.createPaymentRequestFromSelectedProperties();
    this.selectedPaymentRequestEvent.emit(paymentRequest);
    //TODO: Emit the payment request

  }

  createPaymentRequestFromSelectedProperties() {
    let paymentTxn: PaymentRequest = new PaymentRequest();
    if (this.paymentType == PaymentType.ACH) {
      paymentTxn.senderPaymentId = this.sourceAch.id;
      paymentTxn.receiverPaymentMethodId = this.sourceAch.fundingSourceId;
      paymentTxn.receiverPaymentId = this.destinationAch.id;
      paymentTxn.receiverPaymentMethodId = this.destinationAch.fundingSourceId;
    } else if (this.paymentType == PaymentType.ManualCheck) {
      paymentTxn.checkOrReferenceNumber = this.overRideCheckOrReferenceNumber;
    } else if (this.paymentType == PaymentType.Check) {
      if (this.overRideCheckOrReferenceNumber) {
        paymentTxn.checkOrReferenceNumber = this.overRideCheckOrReferenceNumber;
      }
      paymentTxn.orgAchIdForCheck = this.achForCheckPayment.id;
    }
    paymentTxn.paymentType = this.paymentType;
    return paymentTxn;
  }

}
